import CampaignTokenGate from './CampaignTokenGate.vue'

export default CampaignTokenGate
